module.exports = __webpack_public_path__ + "media/images/preview_diary_1-7ffc519ec5b18d9d6ff703a081dc7805.webp";